import { IAdvantageItemProps } from '../../../components/Advantages/utils/types';
import AGENT_ITEM_IMAGE_1 from '../assets/agent_1.svg';
import AGENT_ITEM_IMAGE_2 from '../assets/agent_2.png';
import AGENT_ITEM_IMAGE_3 from '../assets/agent_3.png';
import HOMEOWNER_ITEM_IMAGE_1 from '../assets/homeowner_1.svg';
import HOMEOWNER_ITEM_IMAGE_2 from '../assets/homeowner_2.svg';
import HOMEOWNER_ITEM_IMAGE_3 from '../assets/homeowner_3.svg';
import TENANT_ITEM_IMAGE_1 from '../assets/tenant_1.svg';
import TENANT_ITEM_IMAGE_2 from '../assets/tenant_2.svg';
import TENANT_ITEM_IMAGE_3 from '../assets/tenant_3.svg';

export const TENANTS_ADVANTAGES_ITEMS: IAdvantageItemProps[] = [
  {
    heading: 'Собственник проверен',
    title: 'Госуслуги гарантируют: можете быть уверены, что договор подпишет настоящий владелец жилья',
    image: TENANT_ITEM_IMAGE_1,
  },
  {
    heading: 'Всё одобрено юристами',
    title:
      'Договор проверен специалистами Госуслуг и имеет такую же силу, как бумажный: все права и обязанности сторон зафиксированы',
    image: TENANT_ITEM_IMAGE_2,
  },
  {
    heading: 'Никакой бюрократии',
    title: 'Онлайн-договор хранится в личном кабинете на Госуслугах — никогда не затеряется среди других бумажек',
    image: TENANT_ITEM_IMAGE_3,
  },
];

export const HOMEOWNER_ADVANTAGES_ITEMS: IAdvantageItemProps[] = [
  {
    heading: 'Арендатор проверен',
    title: 'Личность будет подтверждена через Госуслуги',
    image: HOMEOWNER_ITEM_IMAGE_1,
  },
  {
    heading: 'Всё одобрено юристами',
    title:
      'Договор проверен специалистами Госуслуг и имеет такую же силу, как бумажный: все права и обязанности сторон зафиксированы',
    image: HOMEOWNER_ITEM_IMAGE_2,
  },
  {
    heading: 'Никакой бюрократии',
    title: 'Онлайн-договор хранится в личном кабинете на Госуслугах — никогда не затеряется среди других бумажек',
    image: HOMEOWNER_ITEM_IMAGE_3,
  },
];

export const AGENT_ADVANTAGES_ITEMS: IAdvantageItemProps[] = [
  {
    heading: 'Всё одобрено юристами',
    title:
      'Договор проверен специалистами Госуслуг и имеет такую же силу, как бумажный: все права и обязанности сторон зафиксированы',
    image: AGENT_ITEM_IMAGE_1,
  },
  {
    heading: 'Арендатор и собственник проверены',
    title: 'Личности участников договора и право собственности официально подтвердят — так спокойнее для всех',
    image: AGENT_ITEM_IMAGE_2,
  },
  {
    heading: 'Никакой возни с бумажками',
    title: 'Подход современнее, времени на другие задачи — больше',
    image: AGENT_ITEM_IMAGE_3,
  },
];
